import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import { CartProvider } from '@/contexts/CartContext';
import { WishlistProvider } from '@/contexts/WishlistContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import Navbar from '@/components/Navbar';
import VisitTracker from '@/components/VisitTracker';
import ScrollToTop from '@/components/ScrollToTop';
import Footer from '@/components/Footer';
import Chatbot from '@/components/Chatbot';
import Cart from '@/components/Cart';
import InstallAppPrompt from '@/components/InstallAppPrompt';
import NotificationPrompt from '@/components/NotificationPrompt';
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import ProductDetail from '@/pages/ProductDetail';
import Login from '@/pages/Login';
import Account from '@/pages/Account';
import Checkout from '@/pages/Checkout';
import OrderSuccess from '@/pages/OrderSuccess';
import Invoice from '@/pages/Invoice';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import Offers from '@/pages/Offers';
import Wishlist from '@/pages/Wishlist';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import ReturnPolicy from '@/pages/ReturnPolicy';
import Terms from '@/pages/Terms';
import FAQ from '@/pages/FAQ';
import AddAddress from '@/pages/AddAddress';
import NotFound from '@/pages/NotFound';
import RequireAddress from '@/components/RequireAddress';
import { SettingsProvider, useSettings } from '@/contexts/SettingsContext';
import { SiteEditorProvider } from '@/contexts/SiteEditorContext';
import '@/App.css';

// زر واتساب العائم — الرقم من إعدادات لوحة التحكم
const WhatsAppFab = () => {
  const { whatsapp_url } = useSettings();
  if (!whatsapp_url) return null;
  return (
    <a
      href={whatsapp_url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="واتساب"
      className="whatsapp-fab bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
    >
      <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
      </svg>
    </a>
  );
};

function App() {

  return (
    <SettingsProvider>
    <SiteEditorProvider>
    <ThemeProvider>
      <AuthProvider>
        <CartProvider>
        <WishlistProvider>
          <BrowserRouter>
          <div className="App min-h-screen flex flex-col">
            <VisitTracker />
            <ScrollToTop />
            <Navbar />
            <main className="flex-1">
              <RequireAddress>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:id" element={<ProductDetail />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-success/:orderNumber" element={<OrderSuccess />} />
                  <Route path="/orders/:orderNumber/invoice" element={<Invoice />} />
                  <Route path="/add-address" element={<AddAddress />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/offers" element={<Offers />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/return-policy" element={<ReturnPolicy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </RequireAddress>
            </main>
            <Footer />
            <Cart />
            <Chatbot />
            <InstallAppPrompt />
            <NotificationPrompt />
            <WhatsAppFab />
            <Toaster position="top-center" richColors />
          </div>
        </BrowserRouter>
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
    </ThemeProvider>
    </SiteEditorProvider>
    </SettingsProvider>
  );
}

export default App;
